<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input *ngIf="fabricsGrpId === '0'" ttLabel="fabricsgrp_id" [(ttModel)]="edit.fabricsgrp_id"></tt-input>
        <tt-input *ngIf="fabricsGrpId !== '0'" ttLabel="fabricsgrp_id" [ttModel]="edit.fabricsgrp_id" ttReadonly></tt-input>
        <tt-input ttLabel="fabricsgrp_name" [(ttModel)]="edit.fabricsgrp_name"></tt-input>
        <tt-button-save ttText="fabricsgrp_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ng-if="vm.model.fabricsGrpId === '0'" class="col-xs-12 sp-0" tt-label="fabricsgrp_id" tt-model="vm.model.edit.fabricsgrp_id" tt-change="vm.model.edit.fabricsgrp_id = $value" tt-placeholder=""></tt-input>
        <tt-input ng-if="vm.model.fabricsGrpId !== '0'" class="col-xs-12 sp-0" tt-label="fabricsgrp_id" tt-model="vm.model.edit.fabricsgrp_id" tt-change="vm.model.edit.fabricsgrp_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="fabricsgrp_name" tt-model="vm.model.edit.fabricsgrp_name" tt-change="vm.model.edit.fabricsgrp_name = $value" tt-placeholder=""></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="fabricsgrp_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
